class ScrollingMediaWithContent extends HTMLElement {
  #observer;
  #frame;

  connectedCallback() {
    const content = this.querySelector('.group-block-content');
    [...(content?.children || [])].forEach((item, index) => item.style.setProperty('--scroll-item-index', index));

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.dataset.inView = '';
      return;
    }

    this.#observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        this.dataset.inView = '';
        this.#observer?.disconnect();
      },
      { threshold: 0.2 }
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    cancelAnimationFrame(this.#frame);
  }
}

if (!customElements.get('scrolling-media-with-content')) {
  customElements.define('scrolling-media-with-content', ScrollingMediaWithContent);
}
